import { parsePhoneNumberFromString } from "libphonenumber-js";
export function _parsePhoneNumber(countryCode, phone) {
  let phoneCountryCode = countryCode + " " + phone;
  let phoneNumber = parsePhoneNumberFromString(phoneCountryCode);
  return {
    isValid: phoneNumber ? phoneNumber.isValid() : false,
    format_internal: phoneNumber
      ? phoneNumber.formatInternational().replace(/ /g, "")
      : "",
    format_not_calling: phoneNumber
      ? phoneNumber
          .formatInternational()
          .replace(countryCode, "")
          .replace(/ /g, "")
      : "",
    format_national: phoneNumber
      ? phoneNumber.formatNational().replace(/ /g, "")
      : ""
  };
}
export function getNumberOnString(text) {
  let result = text.match(/\d+/g);
  return result ? result.join("") : "";
}
